// Frontpage Top Main Slider Video Viewport Resize

var min_w = 300; // minimum video width allowed
var vid_w_orig; // original video dimensions
var vid_h_orig;

jQuery(function () {
  // runs after DOM has loaded

  vid_w_orig = parseInt(jQuery("video").attr("width"));
  vid_h_orig = parseInt(jQuery("video").attr("height"));
  jQuery("#debug").append("<p>DOM loaded</p>");

  jQuery(window).resize(function () {
    resizeToCover();
  });
  jQuery(window).trigger("resize");
});

function resizeToCover() {
  // set the video viewport to the window size
  jQuery(".slide-video").width(jQuery(window).width());
  jQuery(".slide-video").height(jQuery(window).height());

  // use largest scale factor of horizontal/vertical
  var scale_h = jQuery(window).width() / vid_w_orig;
  var scale_v = jQuery(window).height() / vid_h_orig;
  var scale = scale_h > scale_v ? scale_h : scale_v;

  // don't allow scaled width < minimum video width
  if (scale * vid_w_orig < min_w) {
    scale = min_w / vid_w_orig;
  }

  // now scale the video
  jQuery("video").width(scale * vid_w_orig);
  jQuery("video").height(scale * vid_h_orig);
  // and center it by scrolling the video viewport
  jQuery(".slide-video").scrollLeft(
    (jQuery("video").width() - jQuery(window).width()) / 2
  );
  jQuery(".slide-video").scrollTop(
    (jQuery("video").height() - jQuery(window).height()) / 2
  );
}

// Mainpage Top Video Slide Wrapper

jQuery(document).ready(function () {
  jQuery(".main-slider").on("init breakpoint", function (event, slick) {
    if (!isChanging) {
      jQuery("#breakpointValue").text(String(slick.activeBreakpoint));
      // Prevent infinite loop
      isChanging = true;
      // The highest breakpoint is null
      if (
        slick.activeBreakpoint &&
        slick.activeBreakpoint <= breakpointMobile
      ) {
        if (!isFiltered) {
          slick.slickFilter(":not(.hide-on-mobile)");
          isFiltered = true;
        }
      } else {
        if (isFiltered) {
          slick.slickUnfilter();
          isFiltered = false;
        }
      }
      isChanging = false;
    }
  });

  jQuery(".main-slider").on("init", function (e, slick) {
    var $firstAnimatingElements = jQuery(
      "div.slideranimation:first-child"
    ).find("[data-animation]");
    doAnimations($firstAnimatingElements);
  });
  jQuery(".main-slider").on(
    "beforeChange",
    function (e, slick, currentSlide, nextSlide) {
      var $animatingElements = jQuery(
        'div.slideranimation[data-slick-index="' + nextSlide + '"]'
      ).find("[data-animation]");
      doAnimations($animatingElements);
    }
  );

  var slideWrapper = jQuery(".main-slider"),
    iframes = slideWrapper.find(".embed-player"),
    lazyImages = slideWrapper.find(".slide-image"),
    lazyCounter = 0;

  // POST commands to YouTube or Vimeo API
  function postMessageToPlayer(player, command) {
    if (player == null || command == null) return;
    player.contentWindow.postMessage(JSON.stringify(command), "*");
  }

  // When the slide is changing
  function playPauseVideo(slick, control) {
    var currentSlide, slideType, startTime, player, video;

    currentSlide = slick.find(".slick-current");
    slideType = currentSlide.attr("class").split(" ")[1];
    player = currentSlide.find("iframe").get(0);
    startTime = currentSlide.data("video-start");

    // console.log('Current Slide:');
    // console.log(currentSlide);

    // console.log('Type:');
    // console.log(slideType);

    if (slideType === "vimeo") {
      switch (control) {
        case "play":
          if (
            startTime != null &&
            startTime > 0 &&
            !currentSlide.hasClass("started")
          ) {
            currentSlide.addClass("started");
            postMessageToPlayer(player, {
              method: "setCurrentTime",
              value: startTime,
            });
          }
          postMessageToPlayer(player, {
            method: "play",
            value: 1,
          });
          break;
        case "pause":
          postMessageToPlayer(player, {
            method: "pause",
            value: 1,
          });
          break;
      }
    } else if (slideType === "youtube") {
      switch (control) {
        case "play":
          postMessageToPlayer(player, {
            event: "command",
            func: "mute",
          });
          postMessageToPlayer(player, {
            event: "command",
            func: "playVideo",
          });
          break;
        case "pause":
          postMessageToPlayer(player, {
            event: "command",
            func: "pauseVideo",
          });
          break;
      }
    } else if (slideType === "video") {
      // currentSlide = document.getElementsByClassName('responsive-video');
      // console.log(currentSlide);
      // currentSlide = currentSlide[0];
      // console.log(currentSlide);
      video = currentSlide.children("video").get(0);
      // console.log(video);
      if (video != null) {
        if (control === "play") {
          video.play();
        } else {
          video.pause();
        }
      }
    }
  }

  // // Resize player
  // function resizePlayer(iframes, ratio) {
  // 	if (!iframes[0]) return;
  // 	var win = $('.main-slider'),
  // 		width = win.width(),
  // 		playerWidth,
  // 		height = win.height(),
  // 		playerHeight,
  // 		ratio = ratio || 16 / 9;

  // 	iframes.each(function () {
  // 		var current = $(this);
  // 		if (width / ratio < height) {
  // 			playerWidth = Math.ceil(height * ratio);
  // 			current.width(playerWidth).height(height).css({
  // 				left: (width - playerWidth) / 2,
  // 				top: 0
  // 			});
  // 		} else {
  // 			playerHeight = Math.ceil(width / ratio);
  // 			current.width(width).height(playerHeight).css({
  // 				left: 0,
  // 				top: (height - playerHeight) / 2
  // 			});
  // 		}
  // 	});
  // }

  // DOM Ready
  jQuery(function () {
    // Initialize
    // slideWrapper.on('init', function (slick) {
    // 	slick = $(slick.currentTarget);
    // 	setTimeout(function () {
    // 		playPauseVideo(slick, 'play');
    // 	}, 1000);
    // 	resizePlayer(iframes, 16 / 9);
    // });
    // slideWrapper.on('beforeChange', function (event, slick) {
    // 	slick = $(slick.$slider);
    // 	playPauseVideo(slick, 'pause');
    // });
    // slideWrapper.on('afterChange', function (event, slick) {
    // 	slick = $(slick.$slider);
    // 	playPauseVideo(slick, 'play');
    // });
    // slideWrapper.on('lazyLoaded', function (event, slick, image, imageSource) {
    // 	lazyCounter++;
    // 	if (lazyCounter === lazyImages.length) {
    // 		lazyImages.addClass('show');
    // 		// slideWrapper.slick("slickPlay");
    // 	}
    // });

    //start the slider
    slideWrapper.slick({
      // fade:true,
      autoplaySpeed: 4000,
      lazyLoad: "ondemand",
      speed: 600,
      arrows: true,
      dots: false,
      fade: true,
      cssEase: "cubic-bezier(0.87, 0.03, 0.41, 0.9)",
    });
  });

  function doAnimations(elements) {
    var animationEndEvents =
      "webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend";
    elements.each(function () {
      var $this = $(this);
      var $animationDelay = $this.data("delay");
      var $animationType = "animated " + $this.data("animation");
      $this.css({
        visibility: "visible",
        "animation-delay": $animationDelay,
        "-webkit-animation-delay": $animationDelay,
      });
      $this.addClass($animationType).one(animationEndEvents, function () {
        $this.removeClass($animationType);
      });
    });
  }

  // Resize event
  // $(window).on('resize.slickVideoPlayer', function () {
  // 	resizePlayer(iframes, 16 / 9);
  // });
});

jQuery(".aktivitaets-slider").slick({
  autoplaySpeed: 5000,
  autoplay: false,
  prevArrow: ".aktiprev",
  nextArrow: ".aktinext",
  dots: false,
  infinite: true,
  speed: 2500,
  slidesToShow: 4,
  slidesToScroll: 1,
  // prevArrow: false,
  // nextArrow: false,
  lazyLoad: "progressive",
  responsive: [
    // {
    //   breakpoint: 1024,
    //   settings: {
    //     slidesToShow: 3,
    //     slidesToScroll: 1,
    //     infinite: true,
    //     dots: false
    //   }
    // },
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1,
      },
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1,
      },
    },
    // You can unslick at a given breakpoint now by adding:
    // settings: "unslick"
    // instead of a settings object
  ],
});

jQuery(".kultur-modul-slider").slick({
  infinite: false,
  autoplaySpeed: 5000,
  autoplay: false,
  dots: false,
  speed: 250,
  // prevArrow: $('.slick-kultur-prev'),
  // nextArrow: $('.slick-kultur-next'),
  slidesToShow: 3,
  slidesToScroll: 1,
  // prevArrow: false,
  // nextArrow: false,
  lazyLoad: "ondemand",
  responsive: [
    // {
    //   breakpoint: 1024,
    //   settings: {
    //     slidesToShow: 3,
    //     slidesToScroll: 1,
    //     infinite: true,
    //     dots: false
    //   }
    // },
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1,
      },
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
      },
    },
    // You can unslick at a given breakpoint now by adding:
    // settings: "unslick"
    // instead of a settings object
  ],
});

var $partnerModulSlider = jQuery(".partner-modul-slider");
var partnerModulSliderPrevLabel =
  $partnerModulSlider.data("prev-label") || "Vorherige Partner anzeigen";
var partnerModulSliderNextLabel =
  $partnerModulSlider.data("next-label") || "Nächste Partner anzeigen";
var partnerModulSliderShouldReduceMotion =
  window.matchMedia &&
  window.matchMedia("(prefers-reduced-motion: reduce)").matches;

function escapePartnerModulSliderLabel(label) {
  return jQuery("<div>").text(label).html();
}

function partnerModulSliderArrow(direction, label) {
  // Icon-Markup kommt aus inc/icons.php ueber wp_localize_script — kein
  // Klassenname mehr, seit die Icons Inline-SVG statt Webfont sind.
  var icons =
    (window.weissenstadt_bundle_object &&
      window.weissenstadt_bundle_object.icons) ||
    {};
  var icon =
    (direction === "prev" ? icons.chevronLeft : icons.chevronRight) || "";

  return (
    '<button class="frontpage-partner-arrow frontpage-partner-arrow--' +
    direction +
    '" type="button" aria-label="' +
    escapePartnerModulSliderLabel(label) +
    '">' +
    icon +
    "</button>"
  );
}

function normalizePartnerModulSliderFocus(event, slick) {
  var $slider = slick && slick.$slider ? slick.$slider : $partnerModulSlider;

  window.setTimeout(function () {
    $slider.find(".slick-slide").attr("tabindex", "-1");
    $slider
      .find(".slick-cloned a, .slick-slide[aria-hidden='true'] a")
      .attr("tabindex", "-1");
    $slider.find(".slick-active a").attr("tabindex", "0");
  }, 0);
}

$partnerModulSlider.on(
  "init reInit afterChange breakpoint setPosition",
  normalizePartnerModulSliderFocus
);

// Relaunch 2026: the redesign's motion tuning (gentle autoplay, soft easing,
// pause on hover/focus, per-width breakpoints) merged onto this theme's July
// rework (accessible arrows + focus normalization). Autoplay stays off for
// visitors who prefer reduced motion.
$partnerModulSlider.slick({
  dots: false,
  infinite: true,
  autoplay: !partnerModulSliderShouldReduceMotion,
  autoplaySpeed: 3200,
  pauseOnHover: true,
  pauseOnFocus: true,
  swipeToSlide: true,
  touchThreshold: 10,
  speed: partnerModulSliderShouldReduceMotion ? 0 : 700,
  cssEase: "cubic-bezier(0.22, 1, 0.36, 1)",
  slidesToShow: 5,
  slidesToScroll: 1,
  prevArrow: partnerModulSliderArrow("prev", partnerModulSliderPrevLabel),
  nextArrow: partnerModulSliderArrow("next", partnerModulSliderNextLabel),
  lazyLoad: "progressive",
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1,
      },
    },
    {
      breakpoint: 640,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1,
      },
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
      },
    },
  ],
});

// $('.buerger-slider').on('afterChange', function (event, slick, currentSlide) {

// 	if (currentSlide === 6) {
// 		$('.slick-next').addClass('hidden');
// 	}
// 	else {
// 		$('.slick-next').removeClass('hidden');
// 	}

// 	if (currentSlide === 0) {
// 		$('.slick-prev').addClass('hidden');
// 	}
// 	else {
// 		$('.slick-prev').removeClass('hidden');
// 	}
// });
jQuery(".buerger-slider").slick({
  dots: false,
  infinite: false,
  slidesToShow: 5,
  slidesToScroll: 1,
  // prevArrow: true,
  // nextArrow: true,
  lazyLoad: "progressive",
  prevArrow: ".buergerprev",
  nextArrow: ".buergernext",
  autoplay: false,
  autoplaySpeed: 5000,
  speed: 300,
  responsive: [
    // {
    //   breakpoint: 1024,
    //   settings: {
    //     slidesToShow: 3,
    //     slidesToScroll: 1,
    //     infinite: true,
    //     dots: false
    //   }
    // },
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1,
      },
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
      },
    },
    // You can unslick at a given breakpoint now by adding:
    // settings: "unslick"
    // instead of a settings object
  ],
});

var breakpointMobile = 1328,
  isChanging = false,
  isFiltered = false;

jQuery(".footer-slider").slick({
  infinite: true,
  autoplaySpeed: 10000,
  fade: true,
  speed: 1000,
  // cssEase: "linear",
  autoplay: true,
  dots: true,
  lazyLoad: "ondemand",
  pauseOnHover: false,
  responsive: [{ breakpoint: 500 }, { breakpoint: 700 }, { breakpoint: 1328 }],
  // prevArrow: jQuery(".footer-prev"),
  // nextArrow: jQuery(".footer-next"),
});
